<template>
    <div class="flex justify-between gap-4 p-12 border-t border-grey -mt-[1px]">
        <button
            class="flex gap-2 items-center flex-row-reverse text-blue disabled:opacity-50 disabled:pointer-events-none"
            @click="changePage(-1)"
            :disabled="page <= 1"
        >
            <span class="uppercase text-md">{{ prevLabel }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
            </svg>
        </button>
        <button
            class="flex gap-2 items-center text-blue disabled:opacity-50 disabled:pointer-events-none"
            @click="changePage(1)"
            :disabled="maxPage && page >= maxPage"
        >
            <span class="uppercase text-md">{{ nextLabel }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3" />
            </svg>
        </button>
    </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
    modelValue: {
        type: Number,
        required: true,
    },
    maxPage: {
        type: Number,
        default: null,
    },
    prevLabel: {
        type: String,
        default: "Previous",
    },
    nextLabel: {
        type: String,
        default: "Next",
    },
});

const emit = defineEmits(["update:modelValue"]);

const page = computed(() => props.modelValue);

function changePage(direction) {
    let newPage = page.value + direction;

    if (newPage < 1) newPage = 1;
    if (props.maxPage && newPage > props.maxPage) newPage = props.maxPage;

    emit("update:modelValue", newPage);
}
</script>
